import React, { useEffect, useState } from "react";
import { ChevronRight } from "lucide-react";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../../utils/firebase";


const QuickOrder = () => {
  const [quickOrderItems, setQuickOrderItems] = useState([]);
  
  useEffect(() => {
    const fetchQuickOrderItems = async () => {
      try {
        const q = query(
          collection(db, "orders"),
          orderBy("createdAt", "desc"),
          limit(10)
        );
        const snapshot = await getDocs(q);
        const uniqueItems = Array.from(
          new Map(
            snapshot.docs
              .flatMap((doc) => doc.data().items)
              .map((item) => [item.id, item])
          ).values()
        );
        setQuickOrderItems(uniqueItems);
      } catch (error) {
        console.error("Error fetching quick order items:", error);
      }
    };
    fetchQuickOrderItems();
  }, []);
  
  return (
    <section className="py-24 bg-[#F8F5EE] border-y border-[#ECE5D9]">

      <div className="max-w-[1700px] mx-auto px-6 lg:px-12">

        {/* HEADER */}

        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">

          <div>

            <span className="text-[#C86A4B] uppercase tracking-[0.3em] text-xs font-bold">

              Quick Procurement

            </span>

            <h2 className="text-4xl md:text-5xl font-black text-[#2C3E2B] mt-4">

              Frequently Ordered Items

            </h2>

            <p className="text-[#666] mt-5 max-w-3xl leading-8 text-lg">

              Operational essentials and wholesale products catalog.

            </p>

          </div>

          <button className="group flex items-center gap-2 text-[#C86A4B] font-bold text-sm">

            View Full Catalog

            <ChevronRight className="w-4 h-4 group-hover:translate-x-1 transition" />

          </button>

        </div>

        {/* GRID */}

        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">

          {quickOrderItems.map((item, index) => {
            return (

              <div
                key={index}
                className="bg-white rounded-[28px] overflow-hidden border border-[#ECE5D9] hover:shadow-xl transition-all duration-300"
              >

                {/* IMAGE */}

                <div className="relative h-40 overflow-hidden">

                  <div className="absolute top-3 left-3 z-10 bg-[#C86A4B] text-white px-3 py-1 rounded-full text-[10px] font-bold">

                    {item.categoryName}

                  </div>

                  <img
                    src={item.image}
                    alt={item.productName}
                    className="w-full h-full object-cover hover:scale-105 transition duration-500"
                  />

                </div>

                {/* CONTENT */}

                <div className="p-5">

                  <h3 className="text-lg font-black text-[#2C3E2B] leading-tight min-h-[48px]">

                    {item.productName}

                  </h3>



                </div>

              </div>

            );
          })}

        </div>

      </div>

    </section>
  );
};

export default QuickOrder;